//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ExportLogClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetEventLogExportLogQueryParameters = {
  studyId: number;
  patientUniqId?: string | null | null;
};

export type GetStatisticsExportLogQueryParameters = {
  studyId: number;
  surveyTypes?: string[] | null;
  formTypes?: string[] | null;
  lifecycleStates?: Types.FormLifecycleState[] | null | null;
  patientUniqId?: string | null | null;
  lastFormResultVersionOnly?: boolean | null | null;
  formResultId?: number | null | null;
};

export type GetStatisticTypesToExportExportLogQueryParameters = {
  studyId: number;
  patientUniqId?: string | null | null;
  withMissedSurveyTypes?: boolean | null | null;
};

    
export function getEventLogUrl(studyId: number, patientUniqId?: string | null | undefined): string {
  let url_ = getBaseUrl() + "/api/export/eventlog/{studyId}?";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
if (patientUniqId !== undefined && patientUniqId !== null)
    url_ += "patientUniqId=" + encodeURIComponent("" + patientUniqId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getEventLogDefaultOptions: UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse> = {
  queryFn: __getEventLog,
};
export function getGetEventLogDefaultOptions(): UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse> {
  return getEventLogDefaultOptions;
};
export function setGetEventLogDefaultOptions(options: UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse>) {
  getEventLogDefaultOptions = options;
}

export function getEventLogQueryKey(dto: GetEventLogExportLogQueryParameters): QueryKey;
export function getEventLogQueryKey(studyId: number, patientUniqId?: string | null | undefined): QueryKey;
export function getEventLogQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId, patientUniqId,  } = params[0] as GetEventLogExportLogQueryParameters;

    return trimArrayEnd([
        'ExportLogClient',
        'getEventLog',
        studyId as any,
        patientUniqId as any,
      ]);
  } else {
    return trimArrayEnd([
        'ExportLogClient',
        'getEventLog',
        ...params
      ]);
  }
}
function __getEventLog(context: QueryFunctionContext) {
  return Client.getEventLog(
      context.queryKey[2] as number,       context.queryKey[3] as string | null | undefined    );
}

export function useGetEventLogQuery<TSelectData = Types.FileResponse, TError = unknown>(dto: GetEventLogExportLogQueryParameters, options?: UseQueryOptions<Types.FileResponse, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Return event log study by id.
 * @param studyId Study Id
 * @param patientUniqId (optional) Unique identifier of the Patient for the current Study (optional)
 */
export function useGetEventLogQuery<TSelectData = Types.FileResponse, TError = unknown>(studyId: number, patientUniqId?: string | null | undefined, options?: UseQueryOptions<Types.FileResponse, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetEventLogQuery<TSelectData = Types.FileResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FileResponse, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  let patientUniqId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId, patientUniqId,  } = params[0] as GetEventLogExportLogQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, patientUniqId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.FileResponse, TError, TSelectData>({
    queryFn: __getEventLog,
    queryKey: getEventLogQueryKey(studyId, patientUniqId),
    ...getEventLogDefaultOptions as unknown as UseQueryOptions<Types.FileResponse, TError, TSelectData>,
    ...options,
  });
}
/**
 * Return event log study by id.
 * @param studyId Study Id
 * @param patientUniqId (optional) Unique identifier of the Patient for the current Study (optional)
 */
export function setGetEventLogData(queryClient: QueryClient, updater: (data: Types.FileResponse | undefined) => Types.FileResponse, studyId: number, patientUniqId?: string | null | undefined) {
  queryClient.setQueryData(getEventLogQueryKey(studyId, patientUniqId),
    updater
  );
}

/**
 * Return event log study by id.
 * @param studyId Study Id
 * @param patientUniqId (optional) Unique identifier of the Patient for the current Study (optional)
 */
export function setGetEventLogDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FileResponse | undefined) => Types.FileResponse) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getStatisticsUrl(studyId: number, surveyTypes?: string[] | undefined, formTypes?: string[] | undefined, lifecycleStates?: Types.FormLifecycleState[] | null | undefined, patientUniqId?: string | null | undefined, lastFormResultVersionOnly?: boolean | null | undefined, formResultId?: number | null | undefined): string {
  let url_ = getBaseUrl() + "/api/export/statistics/{studyId}?";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
if (surveyTypes === null)
    throw new Error("The parameter 'surveyTypes' cannot be null.");
else if (surveyTypes !== undefined)
    surveyTypes && surveyTypes.forEach(item => { url_ += "surveyTypes=" + encodeURIComponent("" + item) + "&"; });
if (formTypes === null)
    throw new Error("The parameter 'formTypes' cannot be null.");
else if (formTypes !== undefined)
    formTypes && formTypes.forEach(item => { url_ += "formTypes=" + encodeURIComponent("" + item) + "&"; });
if (lifecycleStates !== undefined && lifecycleStates !== null)
    lifecycleStates && lifecycleStates.forEach(item => { url_ += "lifecycleStates=" + encodeURIComponent("" + item) + "&"; });
if (patientUniqId !== undefined && patientUniqId !== null)
    url_ += "patientUniqId=" + encodeURIComponent("" + patientUniqId) + "&";
if (lastFormResultVersionOnly !== undefined && lastFormResultVersionOnly !== null)
    url_ += "lastFormResultVersionOnly=" + encodeURIComponent("" + lastFormResultVersionOnly) + "&";
if (formResultId !== undefined && formResultId !== null)
    url_ += "formResultId=" + encodeURIComponent("" + formResultId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getStatisticsDefaultOptions: UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse> = {
  queryFn: __getStatistics,
};
export function getGetStatisticsDefaultOptions(): UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse> {
  return getStatisticsDefaultOptions;
};
export function setGetStatisticsDefaultOptions(options: UseQueryOptions<Types.FileResponse, unknown, Types.FileResponse>) {
  getStatisticsDefaultOptions = options;
}

export function getStatisticsQueryKey(dto: GetStatisticsExportLogQueryParameters): QueryKey;
export function getStatisticsQueryKey(studyId: number, surveyTypes?: string[] | undefined, formTypes?: string[] | undefined, lifecycleStates?: Types.FormLifecycleState[] | null | undefined, patientUniqId?: string | null | undefined, lastFormResultVersionOnly?: boolean | null | undefined, formResultId?: number | null | undefined): QueryKey;
export function getStatisticsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId, surveyTypes, formTypes, lifecycleStates, patientUniqId, lastFormResultVersionOnly, formResultId,  } = params[0] as GetStatisticsExportLogQueryParameters;

    return trimArrayEnd([
        'ExportLogClient',
        'getStatistics',
        studyId as any,
        surveyTypes as any,
        formTypes as any,
        lifecycleStates as any,
        patientUniqId as any,
        lastFormResultVersionOnly as any,
        formResultId as any,
      ]);
  } else {
    return trimArrayEnd([
        'ExportLogClient',
        'getStatistics',
        ...params
      ]);
  }
}
function __getStatistics(context: QueryFunctionContext) {
  return Client.getStatistics(
      context.queryKey[2] as number,       context.queryKey[3] as string[] | undefined,       context.queryKey[4] as string[] | undefined,       context.queryKey[5] as Types.FormLifecycleState[] | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as boolean | null | undefined,       context.queryKey[8] as number | null | undefined    );
}

export function useGetStatisticsQuery<TSelectData = Types.FileResponse, TError = unknown>(dto: GetStatisticsExportLogQueryParameters, options?: UseQueryOptions<Types.FileResponse, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns all answers for the selected forms and surveys
 * @param studyId Study id
 * @param surveyTypes (optional) Array of survey types to export
 * @param formTypes (optional) Array of form types to export
 * @param lifecycleStates (optional) If not null, only those forms will be exported whose lifecycle state is contained here.
 * @param patientUniqId (optional) Unique identifier of the Patient for the current Study (optional)
 * @param lastFormResultVersionOnly (optional) Get only the last form result version (optional)
 * @param formResultId (optional) 
 */
export function useGetStatisticsQuery<TSelectData = Types.FileResponse, TError = unknown>(studyId: number, surveyTypes?: string[] | undefined, formTypes?: string[] | undefined, lifecycleStates?: Types.FormLifecycleState[] | null | undefined, patientUniqId?: string | null | undefined, lastFormResultVersionOnly?: boolean | null | undefined, formResultId?: number | null | undefined, options?: UseQueryOptions<Types.FileResponse, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetStatisticsQuery<TSelectData = Types.FileResponse, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FileResponse, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  let surveyTypes: any = undefined;
  let formTypes: any = undefined;
  let lifecycleStates: any = undefined;
  let patientUniqId: any = undefined;
  let lastFormResultVersionOnly: any = undefined;
  let formResultId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId, surveyTypes, formTypes, lifecycleStates, patientUniqId, lastFormResultVersionOnly, formResultId,  } = params[0] as GetStatisticsExportLogQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, surveyTypes, formTypes, lifecycleStates, patientUniqId, lastFormResultVersionOnly, formResultId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.FileResponse, TError, TSelectData>({
    queryFn: __getStatistics,
    queryKey: getStatisticsQueryKey(studyId, surveyTypes, formTypes, lifecycleStates, patientUniqId, lastFormResultVersionOnly, formResultId),
    ...getStatisticsDefaultOptions as unknown as UseQueryOptions<Types.FileResponse, TError, TSelectData>,
    ...options,
  });
}
/**
 * Returns all answers for the selected forms and surveys
 * @param studyId Study id
 * @param surveyTypes (optional) Array of survey types to export
 * @param formTypes (optional) Array of form types to export
 * @param lifecycleStates (optional) If not null, only those forms will be exported whose lifecycle state is contained here.
 * @param patientUniqId (optional) Unique identifier of the Patient for the current Study (optional)
 * @param lastFormResultVersionOnly (optional) Get only the last form result version (optional)
 * @param formResultId (optional) 
 */
export function setGetStatisticsData(queryClient: QueryClient, updater: (data: Types.FileResponse | undefined) => Types.FileResponse, studyId: number, surveyTypes?: string[] | undefined, formTypes?: string[] | undefined, lifecycleStates?: Types.FormLifecycleState[] | null | undefined, patientUniqId?: string | null | undefined, lastFormResultVersionOnly?: boolean | null | undefined, formResultId?: number | null | undefined) {
  queryClient.setQueryData(getStatisticsQueryKey(studyId, surveyTypes, formTypes, lifecycleStates, patientUniqId, lastFormResultVersionOnly, formResultId),
    updater
  );
}

/**
 * Returns all answers for the selected forms and surveys
 * @param studyId Study id
 * @param surveyTypes (optional) Array of survey types to export
 * @param formTypes (optional) Array of form types to export
 * @param lifecycleStates (optional) If not null, only those forms will be exported whose lifecycle state is contained here.
 * @param patientUniqId (optional) Unique identifier of the Patient for the current Study (optional)
 * @param lastFormResultVersionOnly (optional) Get only the last form result version (optional)
 * @param formResultId (optional) 
 */
export function setGetStatisticsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FileResponse | undefined) => Types.FileResponse) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getStatisticTypesToExportUrl(studyId: number, patientUniqId?: string | null | undefined, withMissedSurveyTypes?: boolean | null | undefined): string {
  let url_ = getBaseUrl() + "/api/export/statistics/typesToExport/{studyId}?";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
if (patientUniqId !== undefined && patientUniqId !== null)
    url_ += "patientUniqId=" + encodeURIComponent("" + patientUniqId) + "&";
if (withMissedSurveyTypes !== undefined && withMissedSurveyTypes !== null)
    url_ += "withMissedSurveyTypes=" + encodeURIComponent("" + withMissedSurveyTypes) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getStatisticTypesToExportDefaultOptions: UseQueryOptions<Types.StatisticTypesDto, unknown, Types.StatisticTypesDto> = {
  queryFn: __getStatisticTypesToExport,
};
export function getGetStatisticTypesToExportDefaultOptions(): UseQueryOptions<Types.StatisticTypesDto, unknown, Types.StatisticTypesDto> {
  return getStatisticTypesToExportDefaultOptions;
};
export function setGetStatisticTypesToExportDefaultOptions(options: UseQueryOptions<Types.StatisticTypesDto, unknown, Types.StatisticTypesDto>) {
  getStatisticTypesToExportDefaultOptions = options;
}

export function getStatisticTypesToExportQueryKey(dto: GetStatisticTypesToExportExportLogQueryParameters): QueryKey;
export function getStatisticTypesToExportQueryKey(studyId: number, patientUniqId?: string | null | undefined, withMissedSurveyTypes?: boolean | null | undefined): QueryKey;
export function getStatisticTypesToExportQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId, patientUniqId, withMissedSurveyTypes,  } = params[0] as GetStatisticTypesToExportExportLogQueryParameters;

    return trimArrayEnd([
        'ExportLogClient',
        'getStatisticTypesToExport',
        studyId as any,
        patientUniqId as any,
        withMissedSurveyTypes as any,
      ]);
  } else {
    return trimArrayEnd([
        'ExportLogClient',
        'getStatisticTypesToExport',
        ...params
      ]);
  }
}
function __getStatisticTypesToExport(context: QueryFunctionContext) {
  return Client.getStatisticTypesToExport(
      context.queryKey[2] as number,       context.queryKey[3] as string | null | undefined,       context.queryKey[4] as boolean | null | undefined    );
}

export function useGetStatisticTypesToExportQuery<TSelectData = Types.StatisticTypesDto, TError = unknown>(dto: GetStatisticTypesToExportExportLogQueryParameters, options?: UseQueryOptions<Types.StatisticTypesDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns the types of forms and surveys that can be exported
 * @param studyId Study id
 * @param patientUniqId (optional) Unique identifier of the Patient for the current Study (optional)
 * @param withMissedSurveyTypes (optional) 
 */
export function useGetStatisticTypesToExportQuery<TSelectData = Types.StatisticTypesDto, TError = unknown>(studyId: number, patientUniqId?: string | null | undefined, withMissedSurveyTypes?: boolean | null | undefined, options?: UseQueryOptions<Types.StatisticTypesDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetStatisticTypesToExportQuery<TSelectData = Types.StatisticTypesDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.StatisticTypesDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  let patientUniqId: any = undefined;
  let withMissedSurveyTypes: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId, patientUniqId, withMissedSurveyTypes,  } = params[0] as GetStatisticTypesToExportExportLogQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, patientUniqId, withMissedSurveyTypes, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.StatisticTypesDto, TError, TSelectData>({
    queryFn: __getStatisticTypesToExport,
    queryKey: getStatisticTypesToExportQueryKey(studyId, patientUniqId, withMissedSurveyTypes),
    ...getStatisticTypesToExportDefaultOptions as unknown as UseQueryOptions<Types.StatisticTypesDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Returns the types of forms and surveys that can be exported
 * @param studyId Study id
 * @param patientUniqId (optional) Unique identifier of the Patient for the current Study (optional)
 * @param withMissedSurveyTypes (optional) 
 */
export function setGetStatisticTypesToExportData(queryClient: QueryClient, updater: (data: Types.StatisticTypesDto | undefined) => Types.StatisticTypesDto, studyId: number, patientUniqId?: string | null | undefined, withMissedSurveyTypes?: boolean | null | undefined) {
  queryClient.setQueryData(getStatisticTypesToExportQueryKey(studyId, patientUniqId, withMissedSurveyTypes),
    updater
  );
}

/**
 * Returns the types of forms and surveys that can be exported
 * @param studyId Study id
 * @param patientUniqId (optional) Unique identifier of the Patient for the current Study (optional)
 * @param withMissedSurveyTypes (optional) 
 */
export function setGetStatisticTypesToExportDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.StatisticTypesDto | undefined) => Types.StatisticTypesDto) {
  queryClient.setQueryData(queryKey, updater);
}